﻿import { apiLink } from "./../../../constant/api-link";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

/* Import Model*/
import { CustomCostCodeModel } from "../../../model/builk/custom-costcode/custom-costcode.model";
import { ExternalSaleTransactionListModel, ExternalSaleTransactionModel } from "../../../model/builk/custom-costcode-sale/external-sale-transaction.model";
import { SaleTransactionListQueryModel } from "../../../model/builk/package-sale/sale-transaction.model";
import { LocalStorageService } from "angular-2-local-storage";

@Injectable({
    providedIn: "root"
})
export class CustomCostCodeService {

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService,
    ) { }

    GetCustomCostCodeList(): Observable<Array<CustomCostCodeModel>> {

        const url = apiLink.getCustomCostCode;

        return this.http.get<Array<CustomCostCodeModel>>(url);
    }

    getExternalSaleTransaction(query: SaleTransactionListQueryModel): Observable<ExternalSaleTransactionListModel> {
        const url = apiLink.getExternalSaleCustomCostcodeTransaction;
        let params = new HttpParams()
            .set("PageNumber", query.pageNumber.toString())
            .set("PageSize", query.pageSize.toString())
            .set("SortByDesc", query.sortByDesc.toString())
            .set("SortColumn", query.sortColumn.toString());

        if (query.textSearch !== undefined && query.textSearch !== null && query.textSearch !== '') {
            params = params.append("TextSearch", query.textSearch.toString());
        }

        if (query.status !== undefined && query.status !== null) {
            params = params.append("Status", query.status.toString());
        }

        if (query.startDate !== undefined && query.startDate !== null) {
            params = params.append("StartDate", query.startDate.toISOString());
        }

        if (query.endDate !== undefined && query.endDate !== null) {
            params = params.append("EndDate", query.endDate.toISOString());
        }
        return this.http.get<ExternalSaleTransactionListModel>(url, { params: params });
    }

    approvePaymentAndSetCostCode(model: ExternalSaleTransactionModel): Observable<number> {
        const url = apiLink.approvePaymentAndSetCostCode;
        const userSurrKey = this.localStorageService.get<number>("userSurrKey");
        const body = {
            transactionId: model.transactionSurrkey,
            companySurrkey: model.companySurrkey,
            userInfoKey: userSurrKey,
            companyInfoCompanyCountry: model.companyInfoCompanyCountry
        }
        return this.http.post<number>(url, body);
    }
}
